import React from 'react'

const myContext = React.createContext({})

// export const ThingsProvider = myContext.Provider
export const ContextProvider = myContext.Provider

export default myContext
